import React from "react";
import { addForwardMessageData, removeForwardMessageData } from "../../../../../../Redux/feature/forwardMessageDataSlice";
import { store } from "../../../../../../Redux/store";


export default function ForwardMessage(props) {
  const { msgid, timestamp, forward, forwardMessageId, favouriteStatus, selectedToForward = () => {} } = props;
  const [isChecked, setChecked] = React.useState(false);

  const handleChange = () => {
    isChecked === false 
      ? store.dispatch(addForwardMessageData({ msgId: msgid, timestamp, favouriteStatus })) 
      : store.dispatch(removeForwardMessageData(msgid));
      setChecked(!isChecked);
      selectedToForward(!isChecked);
  };

  React.useEffect(() => {
    if (forwardMessageId === msgid && !isChecked && forward) {
      setChecked(true);
      selectedToForward(true);
      store.dispatch(addForwardMessageData({ msgId: msgid, timestamp, favouriteStatus }));
    }
    if (!forward) {
      setChecked(false);
    }
    return () => selectedToForward(false);
  }, [forward, forwardMessageId]);

  return (
    <React.Fragment>
      <label className="forwardLabel" htmlFor={"for" + msgid}></label>
      <div className="forwardedMessage">
        <div className="selectForwardMessage">
          <div className="checkbox">
            <input data-jest-id={"jestHandleChange"} checked={isChecked} onChange={handleChange}  id={"for" + msgid} type="checkbox" />
            <label htmlFor={"for" + msgid}></label>
          </div>
        </div>
      </div>
      <div></div>
    </React.Fragment>
  );
}
